import dexnexResellersRo from "@dexnexLang/ro/dexnex_resellers";
import dexnexChannelsRo from "@dexnexLang/ro/dexnex_channels";
import dexnexOfferingsRo from "@dexnexLang/ro/dexnex_offerings";
import dexnexDealsRo from "@dexnexLang/ro/dexnex_deals";
import dexnexPromosRo from "@dexnexLang/ro/dexnex_promos";

export default {
    en: {},
    ro: {
        'dexnex_resellers': dexnexResellersRo,
        'dexnex_channels': dexnexChannelsRo,
        'dexnex_offerings': dexnexOfferingsRo,
        'dexnex_deals': dexnexDealsRo,
        'dexnex_promos': dexnexPromosRo,
    }
}
